import { useGlobalController } from "@bcm-dev/bcms-vite";
import { useState } from 'react';
import './styles.css';
export default function MobileIntegrationContainer(props) {
  const globalController = useGlobalController();

  const bid = globalController.state.b;
  const cid = globalController.state.branding.options.parent_courseid_rxp22|| globalController.state.c;

  const [contentRef, setContentRef] = useState(null)
  const [src, setSrc] = useState(null)

  const [loaded, setLoaded] =useState(false);
  let selector ="[rxp22_container='true']"; 

const href = window.location.href;
  const mountNode =    contentRef;
  fetch(`/bcms/php/deploy/ClassModel.php?b=${bid}&c=${globalController.state.c}`)
  .then(response => response.json())
  .then((jsonData) => { 
   let module = jsonData.id ? jsonData.id.toLowerCase():"";

   switch(module) {
    case "abi22":
     // setSrc(`/bcms/click/abi22/?b=${bid}&c=${cid}#/payments`);  
     // break;
    case "coasp21":
      //setSrc(`/bcms/click/coasp21/?b=${bid}&c=${cid}#pay-bills-page`);
     // break;
    case "vbn":
     // setSrc(`/bcms/click/vbn/?b=${bid}&c=${cid}#pay-bills-page`);  
      //break;
      case "ro5":
      //  setSrc(`/click/retail/2/?b=${bid}&c=${cid}#main/pay`);  
        //break;  
    default: 
      setSrc(href.split("MobileCapture/")[0]+href.split("MobileCapture/")[1]);
   }
  })
  .catch((error) => {
    // handle your errors here
    console.error(error)
  })  
  if(mountNode && loaded === false ){
        const frame = mountNode.contentWindow.window.frames.frameElement.contentWindow.window.frames.frameElement;
   
        $("body",mountNode.contentWindow).css("zoom","2") 
        $("body",mountNode.contentWindow).addClass("capture-styles") 
 document.demoLoaded=href.split("MobileCapture/")[0]+href.split("MobileCapture/")[1];
 document.loadFrame = function(){
  mountNode.setAttribute("rxp22","true")
  
 }             
      
    }
    
    
   
  return(
    <div className={"mobile-integration integration-container"}>
     <iframe ref={setContentRef} src={src} rxp22="false"/>
    </div>
  );
}


